import { Lock, ShieldCheck, Database, Globe, Eye, FileCheck2, KeyRound, ServerCog } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";

const PILLARS = [
  { icon: Lock, t: "End-to-end Encryption", d: "AES-256 at rest, TLS 1.3 in transit. Every record, every field." },
  { icon: KeyRound, t: "Role-Based Access", d: "Granular RBAC with consent-driven data access for patients and staff." },
  { icon: ShieldCheck, t: "Multi-Factor Authentication", d: "TOTP, biometrics and hardware-key support across all staff apps." },
  { icon: Eye, t: "Full Audit Trails", d: "Every read, edit and consent change tagged, timestamped and immutable." },
  { icon: Database, t: "Data Residency Choices", d: "India · UAE · EU regions. On-prem deployment for enterprise customers." },
];

const COMPLIANCE = ["GDPR", /*"ABDM",*/ "ISO 27001", "NABH-IT", "SOC 2 Type II"];

export default function Security() {
  return (
    <div data-testid="page-security">
      <section className="relative bg-[#0B1220] text-white overflow-hidden">
        <div className="absolute inset-0 bg-grid-dark opacity-40" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-cyan-500 blur-[180px] opacity-20" />
        <div className="relative container-x pt-4 md:pt-6 lg:pt-8 pb-20">
          <SectionHeader
            dark
            eyebrow="Security & Compliance"
            title="Patient trust is the platform."
            titleAccent="We don't get to compromise."
            subtitle="Healthcare-grade security engineered from day zero — not bolted on. Every certification, every region, every audit."
          />
          <div className="mt-10 flex flex-wrap gap-3">
            {COMPLIANCE.map(c => (
              <div key={c} className="px-4 py-2 rounded-full glass-dark text-cyan-200 font-semibold text-sm">
                <FileCheck2 className="inline w-4 h-4 mr-2" /> {c}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-y bg-white">
        <div className="container-x grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-5">
          {PILLARS.map((p, i) => (
            <div
              key={p.t}
              data-testid={`security-pillar-${i + 1}`}
              className={`rounded-2xl border border-slate-200 p-6 hover:shadow-xl hover:-translate-y-1 transition-all md:col-span-2 ${
                i === 3 ? "lg:col-start-2" : ""
              } ${
                i === 4 ? "md:col-start-2 lg:col-start-auto" : ""
              }`}
            >
              <div className="w-12 h-12 rounded-xl bg-slate-900 text-white grid place-items-center">
                <p.icon className="w-5 h-5" />
              </div>
              <h3 className="mt-5 text-xl font-bold">{p.t}</h3>
              <p className="mt-2 text-sm text-slate-600">{p.d}</p>
            </div>
          ))}
        </div>

        {/* <div className="container-x mt-16">
          <div className="rounded-3xl border border-slate-200 p-10 md:p-12 grid md:grid-cols-3 gap-8 bg-[color:var(--paper-2)]">
            <div className="md:col-span-2">
              <div className="eyebrow">Trust Center</div>
              <h3 className="mt-3 text-3xl font-bold" style={{ fontFamily: "'Outfit',sans-serif" }}>
                Detailed compliance reports, pentest summaries and DPA documents available on request.
              </h3>
            </div>
            <div className="flex items-end md:justify-end">
              <a href="mailto:security@saaluvars.com" className="btn-primary">Request Security Pack <Globe className="w-4 h-4" /></a>
            </div>
          </div>
        </div> */}
      </section>
    </div>
  );
}
